import { useMe } from './queries';

export function useCan(): (permission: string) => boolean {
  const me = useMe();
  const perms = me.data?.permissions ?? [];
  return (permission) => perms.includes(permission);
}
